import React, { useState, useEffect, useRef, useMemo } from "react";
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';

import { peticionGet } from "Componentes/ComponenteAxios";
import MigaPan from "Componentes/MigaPan";
import TarjetaDosLineas from "Componentes/TarjetaDosLineas";


const Dashboard = () => {

  const migaPanRef = useRef();
  const [registros, setRegistros] = useState([]);

  // ************************************************************************
  // ********** RECUPERA LOS DATOS NECESARIOS
  // ************************************************************************ 
  useEffect(() => {
    peticionGet('/dashBoard').then(({ peticion, error, status }) => {
      if (error) {
        migaPanRef.current?.mostrarSnack({
          mensaje: peticion?.mensajeSnack || "No se han podido recuperar los datos",
          tipo: peticion?.tipoSnack || "error"
        });
      } else {
        setRegistros(peticion || {});
      }

    });
  }, []);

  return (

    <Box className="box-contenido-alineado-izquierda">

      <MigaPan
        ref={migaPanRef}
        tituloSeccion="DashBoard"
      />

      <Grid container xs={12} sm={8} md={8} spacing={3} mb={3}>
        <Grid item xs={12} sm={4} md={4}>
          <TarjetaDosLineas titulo="Operaciones Activas" valor={registros.operacionesActivas} />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TarjetaDosLineas titulo="Operaciones Finalizadas" valor={registros.operacionesFinalizadas} />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TarjetaDosLineas titulo="Operaciones Totales" valor={registros.operacionesTotales} />
        </Grid>
      </Grid>

      <Grid container xs={12} sm={8} md={8} spacing={3} mb={3}>
        <Grid item xs={12} sm={4} md={4}>
          <TarjetaDosLineas titulo="Tarifa Activa" valor={registros.tarifaActiva} />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TarjetaDosLineas titulo="Buques" valor={registros.totalBuques} />
        </Grid>
      </Grid>

      <Grid container xs={12} sm={8} md={8} spacing={3} mb={3}>
        <Grid item xs={12} sm={4} md={4}>
          <TarjetaDosLineas titulo="Total Clientes" valor={registros.totalClientes} />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TarjetaDosLineas titulo="Total Consignatarios" valor={registros.totalConsignatarios} />
        </Grid>
      </Grid>

    </Box >
  );
};

export default Dashboard;
